/**
 * What the window shows for the moment the session probe takes. A bare
 * "Loading…" in the top corner read as a broken page; the mark in the middle
 * reads as the app arriving. It says nothing, so it needs no language.
 *
 * Its own file because both the app and the public pages in front of it show
 * it, and the public pages must not import the app to get it.
 */
export function BootSplash() {
  return (
    <div className="boot-splash" role="status" aria-label="Krevya">
      <img src="/brand/mark-192.png" alt="" width={56} height={56} />
    </div>
  );
}
